export const translations = {
  'en': {
    // Common UI elements
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      refresh: 'Refresh',
      retry: 'Retry',
      close: 'Close',
      submit: 'Submit',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      all: 'All',
      none: 'None',
      select: 'Select',
      clear: 'Clear',
      to: 'to',
      language: 'Language',
      english: 'English',
      traditionalChinese: 'Traditional Chinese'
    },

    // Enhanced AppStore
    enhancedAppStore: {
      title: 'Enhanced App Store',
      description: 'Discover and install AI-powered learning applications',
      discover: 'Discover',
      search: 'Search',
      recommendations: 'Recommendations',
      searchPlaceholder: 'Search for apps...',
      category: 'Category',
      gradeLevel: 'Grade Level',
      rating: 'Rating',
      price: 'Price',
      sortBy: 'Sort By',
      sortOptions: {
        name: 'Name',
        rating: 'Rating',
        downloads: 'Downloads',
        dateAdded: 'Date Added',
        price: 'Price'
      },
      trending: 'Trending Apps',
      recentlyAdded: 'Recently Added',
      recommended: 'Recommended for You',
      noRecommendations: 'No recommendations available. Try installing some apps first!',
      noResults: 'No apps found',
      searchResults: 'Search Results',
      errorMessage: 'Failed to load apps. Please try again.',
      retryButton: 'Retry',
      advancedFilters: 'Advanced Filters',
      allCategories: 'All Categories',
      allGrades: 'All Grades',
      elementary: 'Elementary',
      middleSchool: 'Middle School',
      highSchool: 'High School',
      college: 'College',
      anyRating: 'Any Rating',
      stars: 'Stars',
      allPrices: 'All Prices',
      free: 'Free',
      paid: 'Paid',
      order: 'Order',
      descending: 'Descending',
      ascending: 'Ascending',
      applyFilters: 'Apply Filters',
      clearAll: 'Clear All',
      trial: 'Trial',
      downloads: 'downloads',
      reviews: 'reviews',
      by: 'by',
      unknown: 'Unknown',
      install: 'Install',
      details: 'Details'
    },

    // AI AppStore
    aiAppStore: {
      title: 'AI App Store',
      aiApps: 'AI Applications',
      machineLearning: 'Machine Learning',
      naturalLanguage: 'Natural Language Processing',
      computerVision: 'Computer Vision',
      dataAnalytics: 'Data Analytics',
      aiTools: 'AI Tools',
      smartLearning: 'Smart Learning',
      aiAssisted: 'AI-Assisted Learning',
      personalized: 'Personalized Education',
      adaptiveLearning: 'Adaptive Learning'
    },

    // Developer Portal
    developerPortal: {
      title: 'Developer Portal',
      dashboard: 'Dashboard',
      myApps: 'My Apps',
      submitApp: 'Submit New App',
      appManagement: 'App Management',
      analytics: 'Analytics',
      revenue: 'Revenue',
      settings: 'Settings',
      profile: 'Developer Profile',
      documentation: 'Documentation',
      apiKeys: 'API Keys',
      appStats: 'App Statistics',
      userReviews: 'User Reviews',
      appUpdates: 'App Updates',
      versionHistory: 'Version History',
      changelog: 'Changelog',
      releaseNotes: 'Release Notes'
    },

    // Admin Review System
    adminReviewSystem: {
      title: 'Admin Review System',
      pendingReviews: 'Pending Reviews',
      approvedApps: 'Approved Apps',
      rejectedApps: 'Rejected Apps',
      reviewQueue: 'Review Queue',
      appDetails: 'App Details',
      developerInfo: 'Developer Information',
      appDescription: 'App Description',
      features: 'Features',
      screenshots: 'Screenshots',
      demoVideo: 'Demo Video',
      reviewNotes: 'Review Notes',
      approve: 'Approve',
      reject: 'Reject',
      requestRevision: 'Request Revision',
      revisionNotes: 'Revision Notes',
      reviewStatus: 'Review Status',
      submittedDate: 'Submitted Date',
      reviewedDate: 'Reviewed Date',
      reviewer: 'Reviewer',
      reviewHistory: 'Review History',
      noPendingReviews: 'No pending reviews',
      noApprovedApps: 'No approved apps',
      noRejectedApps: 'No rejected apps'
    },

    // Billing Dashboard
    billingDashboard: {
      title: 'Billing Dashboard',
      overview: 'Overview',
      billingPlans: 'Billing Plans',
      subscriptions: 'Subscriptions',
      tokenPurchase: 'Token Purchase',
      usageHistory: 'Usage History',
      paymentMethods: 'Payment Methods',
      invoices: 'Invoices',
      currentPlan: 'Current Plan',
      nextBilling: 'Next Billing Date',
      tokensRemaining: 'Tokens Remaining',
      totalSpent: 'Total Spent',
      monthlyUsage: 'Monthly Usage',
      planFeatures: 'Plan Features',
      upgradePlan: 'Upgrade Plan',
      cancelSubscription: 'Cancel Subscription',
      addTokens: 'Add Tokens',
      tokenAmount: 'Token Amount',
      tokenPrice: 'Token Price',
      totalCost: 'Total Cost',
      purchaseTokens: 'Purchase Tokens',
      paymentSuccess: 'Payment Successful',
      paymentFailed: 'Payment Failed',
      insufficientTokens: 'Insufficient Tokens',
      buyMoreTokens: 'Buy More Tokens'
    },

    // App Details
    appDetails: {
      title: 'App Details',
      overview: 'Overview',
      description: 'Description',
      features: 'Features',
      requirements: 'Requirements',
      screenshots: 'Screenshots',
      reviews: 'Reviews',
      ratings: 'Ratings',
      download: 'Download',
      install: 'Install',
      uninstall: 'Uninstall',
      update: 'Update',
      version: 'Version',
      size: 'Size',
      developer: 'Developer',
      category: 'Category',
      tags: 'Tags',
      lastUpdated: 'Last Updated',
      releaseDate: 'Release Date',
      compatibility: 'Compatibility',
      permissions: 'Permissions',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      support: 'Support',
      website: 'Website',
      email: 'Email',
      phone: 'Phone',
      averageRating: 'Average Rating',
      totalReviews: 'Total Reviews',
      writeReview: 'Write Review',
      helpful: 'Helpful',
      notHelpful: 'Not Helpful',
      report: 'Report',
      share: 'Share',
      favorite: 'Favorite',
      addToWishlist: 'Add to Wishlist'
    },

    // Categories
    categories: {
      education: 'Education',
      productivity: 'Productivity',
      entertainment: 'Entertainment',
      utilities: 'Utilities',
      games: 'Games',
      health: 'Health & Fitness',
      business: 'Business',
      creativity: 'Creativity',
      social: 'Social',
      news: 'News & Weather',
      travel: 'Travel',
      shopping: 'Shopping',
      finance: 'Finance',
      lifestyle: 'Lifestyle',
      sports: 'Sports',
      music: 'Music',
      video: 'Video',
      photography: 'Photography',
      design: 'Design',
      development: 'Development'
    },

    // Grade Levels
    gradeLevels: {
      preschool: 'Preschool',
      kindergarten: 'Kindergarten',
      grade1: 'Grade 1',
      grade2: 'Grade 2',
      grade3: 'Grade 3',
      grade4: 'Grade 4',
      grade5: 'Grade 5',
      grade6: 'Grade 6',
      grade7: 'Grade 7',
      grade8: 'Grade 8',
      grade9: 'Grade 9',
      grade10: 'Grade 10',
      grade11: 'Grade 11',
      grade12: 'Grade 12',
      college: 'College',
      university: 'University',
      adult: 'Adult',
      allAges: 'All Ages'
    },

    // Status
    status: {
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      suspended: 'Suspended',
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived',
      beta: 'Beta',
      alpha: 'Alpha',
      stable: 'Stable',
      deprecated: 'Deprecated'
    }
  },

  'zh-TW': {
    // Common UI elements
    common: {
      loading: '載入中...',
      error: '錯誤',
      success: '成功',
      cancel: '取消',
      save: '儲存',
      edit: '編輯',
      delete: '刪除',
      view: '檢視',
      back: '返回',
      next: '下一步',
      previous: '上一步',
      search: '搜尋',
      filter: '篩選',
      sort: '排序',
      refresh: '重新整理',
      retry: '重試',
      close: '關閉',
      submit: '提交',
      confirm: '確認',
      yes: '是',
      no: '否',
      all: '全部',
      none: '無',
      select: '選擇',
      clear: '清除',
      to: '到',
      language: '語言',
      english: 'English',
      traditionalChinese: '繁體中文'
    },

    // Enhanced AppStore
    enhancedAppStore: {
      title: '增強版應用程式商店',
      description: '探索並安裝 AI 驅動的學習應用程式',
      discover: '探索',
      search: '搜尋',
      recommendations: '推薦',
      searchPlaceholder: '搜尋應用程式...',
      category: '分類',
      gradeLevel: '年級',
      rating: '評分',
      price: '價格',
      sortBy: '排序方式',
      sortOptions: {
        name: '名稱',
        rating: '評分',
        downloads: '下載次數',
        dateAdded: '新增日期',
        price: '價格'
      },
      trending: '熱門應用程式',
      recentlyAdded: '最近新增',
      recommended: '為您推薦',
      noRecommendations: '沒有可用的推薦。請先安裝一些應用程式！',
      noResults: '找不到應用程式',
      searchResults: '搜尋結果',
      errorMessage: '載入應用程式失敗，請重試。',
      retryButton: '重試',
      advancedFilters: '進階篩選',
      allCategories: '所有分類',
      allGrades: '所有年級',
      elementary: '小學',
      middleSchool: '中學',
      highSchool: '高中',
      college: '大學',
      anyRating: '任何評分',
      stars: '星',
      allPrices: '所有價格',
      free: '免費',
      paid: '付費',
      order: '順序',
      descending: '降序',
      ascending: '升序',
      applyFilters: '套用篩選',
      clearAll: '清除全部',
      trial: '試用版',
      downloads: '下載',
      reviews: '評論',
      by: '由',
      unknown: '未知',
      install: '安裝',
      details: '詳情'
    },

    // AI AppStore
    aiAppStore: {
      title: 'AI 應用程式商店',
      aiApps: 'AI 應用程式',
      machineLearning: '機器學習',
      naturalLanguage: '自然語言處理',
      computerVision: '電腦視覺',
      dataAnalytics: '資料分析',
      aiTools: 'AI 工具',
      smartLearning: '智慧學習',
      aiAssisted: 'AI 輔助學習',
      personalized: '個人化教育',
      adaptiveLearning: '適應性學習'
    },

    // Developer Portal
    developerPortal: {
      title: '開發者入口',
      dashboard: '儀表板',
      myApps: '我的應用程式',
      submitApp: '提交新應用程式',
      appManagement: '應用程式管理',
      analytics: '分析',
      revenue: '收益',
      settings: '設定',
      profile: '開發者檔案',
      documentation: '文件',
      apiKeys: 'API 金鑰',
      appStats: '應用程式統計',
      userReviews: '使用者評論',
      appUpdates: '應用程式更新',
      versionHistory: '版本歷史',
      changelog: '更新日誌',
      releaseNotes: '發行說明'
    },

    // Admin Review System
    adminReviewSystem: {
      title: '管理員審查系統',
      pendingReviews: '待審查',
      approvedApps: '已核准的應用程式',
      rejectedApps: '已拒絕的應用程式',
      reviewQueue: '審查佇列',
      appDetails: '應用程式詳情',
      developerInfo: '開發者資訊',
      appDescription: '應用程式描述',
      features: '功能特色',
      screenshots: '截圖',
      demoVideo: '示範影片',
      reviewNotes: '審查備註',
      approve: '核准',
      reject: '拒絕',
      requestRevision: '要求修改',
      revisionNotes: '修改備註',
      reviewStatus: '審查狀態',
      submittedDate: '提交日期',
      reviewedDate: '審查日期',
      reviewer: '審查者',
      reviewHistory: '審查歷史',
      noPendingReviews: '沒有待審查項目',
      noApprovedApps: '沒有已核准的應用程式',
      noRejectedApps: '沒有已拒絕的應用程式'
    },

    // Billing Dashboard
    billingDashboard: {
      title: '帳單儀表板',
      overview: '概覽',
      billingPlans: '帳單方案',
      subscriptions: '訂閱',
      tokenPurchase: '代幣購買',
      usageHistory: '使用歷史',
      paymentMethods: '付款方式',
      invoices: '發票',
      currentPlan: '目前方案',
      nextBilling: '下次帳單日期',
      tokensRemaining: '剩餘代幣',
      totalSpent: '總支出',
      monthlyUsage: '每月使用量',
      planFeatures: '方案功能',
      upgradePlan: '升級方案',
      cancelSubscription: '取消訂閱',
      addTokens: '新增代幣',
      tokenAmount: '代幣數量',
      tokenPrice: '代幣價格',
      totalCost: '總成本',
      purchaseTokens: '購買代幣',
      paymentSuccess: '付款成功',
      paymentFailed: '付款失敗',
      insufficientTokens: '代幣不足',
      buyMoreTokens: '購買更多代幣'
    },

    // App Details
    appDetails: {
      title: '應用程式詳情',
      overview: '概覽',
      description: '描述',
      features: '功能特色',
      requirements: '需求',
      screenshots: '截圖',
      reviews: '評論',
      ratings: '評分',
      download: '下載',
      install: '安裝',
      uninstall: '解除安裝',
      update: '更新',
      version: '版本',
      size: '大小',
      developer: '開發者',
      category: '分類',
      tags: '標籤',
      lastUpdated: '最後更新',
      releaseDate: '發行日期',
      compatibility: '相容性',
      permissions: '權限',
      privacyPolicy: '隱私政策',
      termsOfService: '服務條款',
      support: '支援',
      website: '網站',
      email: '電子郵件',
      phone: '電話',
      averageRating: '平均評分',
      totalReviews: '總評論數',
      writeReview: '撰寫評論',
      helpful: '有幫助',
      notHelpful: '沒有幫助',
      report: '檢舉',
      share: '分享',
      favorite: '收藏',
      addToWishlist: '加入願望清單'
    },

    // Categories
    categories: {
      education: '教育',
      productivity: '生產力',
      entertainment: '娛樂',
      utilities: '工具',
      games: '遊戲',
      health: '健康與健身',
      business: '商業',
      creativity: '創意',
      social: '社交',
      news: '新聞與天氣',
      travel: '旅遊',
      shopping: '購物',
      finance: '財務',
      lifestyle: '生活風格',
      sports: '運動',
      music: '音樂',
      video: '影片',
      photography: '攝影',
      design: '設計',
      development: '開發'
    },

    // Grade Levels
    gradeLevels: {
      preschool: '學前',
      kindergarten: '幼稚園',
      grade1: '一年級',
      grade2: '二年級',
      grade3: '三年級',
      grade4: '四年級',
      grade5: '五年級',
      grade6: '六年級',
      grade7: '七年級',
      grade8: '八年級',
      grade9: '九年級',
      grade10: '十年級',
      grade11: '十一年級',
      grade12: '十二年級',
      college: '專科',
      university: '大學',
      adult: '成人',
      allAges: '全年齡'
    },

    // Status
    status: {
      active: '啟用',
      inactive: '停用',
      pending: '待處理',
      approved: '已核准',
      rejected: '已拒絕',
      suspended: '暫停',
      draft: '草稿',
      published: '已發布',
      archived: '已封存',
      beta: '測試版',
      alpha: '開發版',
      stable: '穩定版',
      deprecated: '已棄用'
    }
  }
};
